import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StepIndicatorModel} from "@app/state/models/add-address.model";
import {sendAccounts, updateCurrentStep} from "../../../state/actions/add-address.action";
import {Observable} from "rxjs";
import {selectSendAccounts, selectStepIndicatorIndex} from "../../../state/selectors/add-address.selector";
import {Account} from "@app/models/thirdparty-documents.model";
import {RadioGroupState} from "@vg-constellation/angular-19/radio";
import {AemUtil} from "@app/utils/aem.util";
import {ThirdpartyDocumentsAemItem} from "@app/models/aem.model";
import {
  BROKERAGE_TYPE_FORM_CONTAINER,
  CANCEL_BUTTON,
  CONTINUE_BUTTON, FOR_MUTUAL_FUND_ACCOUNTS_FIELD_GROUP, SELECT_TYPE_FOR_BROKERAGE_LABEL,
  SELECT_TYPE_FOR_MUTUAL_FUNDS_LABEL,
} from '@app/constants/aem.constant';

@Component({
  selector: 'app-brokerage-type',
  templateUrl: './brokerage-type.component.html',
  styleUrls: ['./brokerage-type.component.scss'],
  standalone: false,
})
export class BrokerageTypeComponent implements OnInit, AfterViewInit{
  labels = {
    heading: '',
    brokerageHeading: '',
    mutualFundHeading: '',
    statementsOnly: '',
    confirmationsOnly: '',
    statementsAndConfirmations: '',
    continueButton: '',
    cancelButton: '',
    errorMessage: '',
    selectTypeForMutualFundsLabel: '',
    statementsOnlyAltText: '',
    confirmationsOnlyAltText: '',
    statementsAndConfirmationsAltText: '',
    selectTypeForBrokerageLabel : '',

  };
  currentStepIndicatorIndex$: Observable<number>;
  allAccounts$: Observable<Account[]>
  isMutualFundSelected: boolean = false;
  isBrokerageAccountSelected: boolean = false;
  @Input() thirdpartyDocumentsAemContent: ThirdpartyDocumentsAemItem;
  accounts: any;
  hasError: boolean = false;
  pageLoad:boolean;
  formDetails;
  existingBrokerageOptedFor: string = '';
  private radioState: RadioGroupState;
  constructor(
    private _router: Router,
    private store: Store<StepIndicatorModel>
  ) { }
  ngOnInit(): void {
    this.isMutualFundSelected = false
    this.isBrokerageAccountSelected = false
    // this.currentStepIndicatorIndex$ = this.store.select((state:any) => (state.stepIndicatorReducer.currentStepIndex));
    this.currentStepIndicatorIndex$ = this.store.pipe(select(selectStepIndicatorIndex));
    this.allAccounts$ = this.store.pipe(select(selectSendAccounts))
    this.allAccounts$.pipe().subscribe((data:any) => {
      // console.log(data.accounts)
      this.accounts= JSON.parse(JSON.stringify(data.accounts));
      const brokerageIndex = data.accounts.find((val)=>(val.productType.includes('BROKERAGE') && val.isChecked===true))
      if(brokerageIndex && brokerageIndex !== -1){
        this.isBrokerageAccountSelected = true;
        this.existingBrokerageOptedFor = brokerageIndex.optedFor || '';
      }
      let mutualFundCounter = 0;
      data.accounts.forEach(val => {
       if(val.positions.find(position => position.isChecked===true)) mutualFundCounter++
      })
      if(mutualFundCounter && mutualFundCounter !==-1) this.isMutualFundSelected = true
      // console.log(mutualFundCounter)
      // console.log(this.isBrokerageAccountSelected)
      // console.log(this.isMutualFundSelected)
    });
    window.scrollTo({top: 0, behavior: 'smooth'});
    this.getAemContent();
  }
  private getAemContent(): void {
    this.formDetails = AemUtil.getBrokerageFormDetails(this.thirdpartyDocumentsAemContent, BROKERAGE_TYPE_FORM_CONTAINER);
    if (this.formDetails) {
      this.labels.heading = this.formDetails.containerHeading;
      this.labels.brokerageHeading = this.formDetails.fieldHeading;
      const fields = this.formDetails.fields;
      this.labels.statementsOnly = fields[1].labelText;
      this.labels.statementsOnlyAltText = fields[1].altText;
      this.labels.confirmationsOnly = fields[2].labelText;
      this.labels.confirmationsOnlyAltText = fields[2].altText;
      this.labels.statementsAndConfirmations = fields[3].labelText;
      this.labels.statementsAndConfirmationsAltText = fields[3].altText;
      this.labels.errorMessage = fields[0].primaryErrorMessage;
      this.labels.continueButton=AemUtil.getPrimaryCtaLabel(this.thirdpartyDocumentsAemContent, CONTINUE_BUTTON);
      this.labels.cancelButton=AemUtil.getPrimaryCtaLabel(this.thirdpartyDocumentsAemContent, CANCEL_BUTTON);
      this.labels.selectTypeForMutualFundsLabel=AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsAemContent, SELECT_TYPE_FOR_MUTUAL_FUNDS_LABEL);
      this.labels.mutualFundHeading = AemUtil.getFormFieldLabel(this.thirdpartyDocumentsAemContent,FOR_MUTUAL_FUND_ACCOUNTS_FIELD_GROUP);
      this.labels.selectTypeForBrokerageLabel=AemUtil.getLabelTextFromLabels(this.thirdpartyDocumentsAemContent, SELECT_TYPE_FOR_BROKERAGE_LABEL);
    }
  }
  ngAfterViewInit() {
    this.pageLoad = true;
  }

  goToPage(route?: string) {
    if(this.isBrokerageAccountSelected){
      this.hasError = !this.radioState.hasSelection
    }
    if (route)
      this._router.navigate([route]);
    else if(!this.hasError) {
      this.accounts.forEach(account=>{
        if(account.productType.includes('BROKERAGE') && account.isChecked===true){
          account.optedFor = this.radioState.radioGroupState.inputValue
        }else if(account.productType.includes('MUTUAL_FUND')){
          account.positions.forEach(position=>{
            if(position.isChecked === true) position.optedFor = 'STATEMENTS_CONFIRMATIONS'
          })
        }
      })
      this.store.dispatch(
        sendAccounts({accounts: {accounts:this.accounts}})
      );
      this.store.dispatch(
        updateCurrentStep({currentStepIndex:4})
      );
    }
  }

  radioGroupForBrokerageAccount($event: RadioGroupState) {
    this.radioState = $event
    // console.log($event)
    if(this.pageLoad) this.hasError = !this.radioState.hasSelection;

  }
}
